import { render } from "./MarketingHeader.vue?vue&type=template&id=9cbc407c"
import script from "./MarketingHeader.vue?vue&type=script&lang=js"
export * from "./MarketingHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__